export default {"src":"/_next/static/media/The World Bank logo.c51cda47.svg","height":63,"width":312,"blurWidth":0,"blurHeight":0};